import React, { Component } from 'react';
import Weather from '../components/Weather';

class WeatherPage extends Component {
    render() {
        return (
            <div className="page page-weather">
                <h2 className="page-header">Weather Forecast</h2>
                <Weather key={'weather_for_'+this.props.match.params.woeid} detailed woeid={this.props.match.params.woeid} />
            </div>
        );
    }
}

export default WeatherPage;
